// SeekJobs Autofill (Chrome extension) links and support checks.
// Wording rules live in the website brief: say "Add to Chrome", name only Workday as supported,
// and never offer the install button on phones or tablets.

export const AUTOFILL_STORE_URL = 'https://chromewebstore.google.com/detail/bmajmpddopmodooekejpggcligilflip';
export const AUTOFILL_PAGE_PATH = '/autofill';
export const AUTOFILL_PRIVACY_PATH = '/privacy-policy#browser-extension';

// Job sites the extension fills today. Keep in sync with the extension's content-script matches.
const SUPPORTED_HOSTS = ['myworkdayjobs.com', 'myworkdaysite.com', 'myworkday.com'];

const matchesHost = (hostname, host) => hostname === host || hostname.endsWith(`.${host}`);

export const isAutofillSupportedUrl = url => {
  if (typeof url !== 'string' || !url.trim()) return false;
  const value = url.trim();
  try {
    const { hostname, protocol } = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
    if (protocol !== 'https:' && protocol !== 'http:') return false;
    return SUPPORTED_HOSTS.some(host => matchesHost(hostname.toLowerCase(), host));
  } catch {
    return false;
  }
};

// The external apply link, picked the same way as the apply popup: the first non-empty URL in `job.urls`.
export const getExternalApplyUrl = job => {
  if (!job || job.is_partner_job) return null;
  let urls = job.urls;
  if (typeof urls === 'string') {
    try {
      urls = JSON.parse(urls || '{}');
    } catch {
      return null;
    }
  }
  if (!urls || typeof urls !== 'object') return null;
  return Object.values(urls).find(value => typeof value === 'string' && value.trim()) || null;
};

export const isAutofillSupportedJob = job => isAutofillSupportedUrl(getExternalApplyUrl(job));

// Chrome extensions install only on a computer. iPadOS reports itself as a Mac, so check for touch too.
export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean' && navigator.userAgentData.mobile) return true;
  const ua = navigator.userAgent || '';
  if (/Android|iPhone|iPad|iPod|Mobile|Silk|Kindle|BlackBerry|Opera Mini|IEMobile/i.test(ua)) return true;
  return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
};
